import * as QueryString from 'query-string';

export function removeNewbuildingsFromUrl(url: string) {
  const parsedUrl = QueryString.parseUrl(url, { arrayFormat: 'index', parseNumbers: true, parseBooleans: true });

  delete parsedUrl.query['newbuildings_search'];

  return QueryString.stringifyUrl(parsedUrl, { arrayFormat: 'index' });
}
